import React, { FC } from 'react'

import { Icon1stMonthFreeProps } from './Icon1stMonthFree.types'
import * as Styled from './styles/Icon1stMonthFree.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon1stMonthFree: FC<Icon1stMonthFreeProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon1stMonthFreeProps['size'],
  isResponsive = false,
}: Icon1stMonthFreeProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='m21.03 20.123 4-2.5v13' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M41.14 19.67a6.405 6.405 0 0 1-.028 9.052l-.105.1a6.402 6.402 0 0 1-4.552 7.826l-.13.032a6.4 6.4 0 0 1-7.853 4.5l-.14-.04a6.396 6.396 0 0 1-9.052-.015l-.115-.117a6.4 6.4 0 0 1-7.813-4.568l-.03-.122a6.4 6.4 0 0 1-4.5-7.853c0-.047.028-.095.04-.142a6.403 6.403 0 0 1 .028-9.05l.105-.103a6.4 6.4 0 0 1 4.55-7.823l.13-.032a6.402 6.402 0 0 1 7.855-4.5l.127.035a6.397 6.397 0 0 1 9.05.028l.103.105a6.4 6.4 0 0 1 7.857 4.692 6.4 6.4 0 0 1 4.5 7.852c-.012.048-.027.093-.04.14l.013.003Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.067 37.357c7.311 0 13.238-5.926 13.238-13.237 0-7.31-5.927-13.238-13.238-13.238-7.31 0-13.237 5.927-13.237 13.238 0 7.31 5.927 13.237 13.237 13.237Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default Icon1stMonthFree
